/* eslint-disable */
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SnackbarContextNext = exports.SnackbarContext = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SnackbarContext = _react2.default.createContext();
var SnackbarContextNext = _react2.default.createContext();

exports.SnackbarContext = SnackbarContext;
exports.SnackbarContextNext = SnackbarContextNext;
